import { createContext, FC } from "react";
import useFormContext from "./useFormContext";

interface FormContextProps {
  children: any;
}

export const FormContext = createContext<any>(null);

export const FormContextProvider: FC<FormContextProps> = ({ children }) => {
  const {
    setCustomerData,
    setVehicleData,
    setCurrentStep,
    setViewedPlans,
    setCustomerId,
    customerData,
    resetContext,
    setVehicles,
    vehicleData,
    viewedPlans,
    currentStep,
    customerId,
    vehicles,
    nextStep,
    prevStep,
    setAmis,
    setRate,
    amis,
    rate,
  } = useFormContext();

  return (
    <div>
      <FormContext.Provider
        value={{
          setCustomerData,
          setVehicleData,
          setCurrentStep,
          setViewedPlans,
          setCustomerId,
          customerData,
          resetContext,
          setVehicles,
          vehicleData,
          viewedPlans,
          currentStep,
          customerId,
          vehicles,
          nextStep,
          prevStep,
          setAmis,
          setRate,
          amis,
          rate,
        }}
      >
        {children}
      </FormContext.Provider>
    </div>
  );
};
